import React from 'react';
import logo from '../../assest/logo.png';

export default function BrandLoader({
  label = 'Loading',
  fullScreen = false,
  compact = false,
  className = '',
}) {
  const classes = [
    'brand-loader',
    fullScreen ? 'full-screen' : '',
    compact ? 'compact' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <div className={classes} aria-live="polite" aria-busy="true">
      <div className="brand-loader-mark">
        <span className="brand-loader-fill" aria-hidden="true" />
        <img src={logo} alt="Services and Developer" className="brand-loader-logo" />
      </div>
      <div className="brand-loader-copy">
        <strong>{label}</strong>
        <span>Services and Developer</span>
      </div>
    </div>
  );
}
